module.exports = __webpack_public_path__ + "51d427b0e7cbf100d30148ae17549a7d.svg";